import { createElement, useState, createContext, useContext, ReactNode } from 'react';
import { ViyaThemeContainer, ViyaThemeContainerProps, TypographyWrapper } from '../../theme';
import { defaultThemes } from '../../design-tokens';
import type { TypographyWrapperDataProvider } from '../../theme';

/**
 * This is used internally by AppRoot. Consumers should not need to use this in isolation. Creates internal state for the currently selected theme.
 */
export const ThemeStateProvider = (props: {
  children?: ReactNode;
  viyaEndpoint?: string;
  requestFonts?: boolean;
  ignoreRootFontSize?: boolean;
  typographyDataProvider?: TypographyWrapperDataProvider;
}) => {
  const [theme, setTheme] = useState<ViyaThemeContainerProps['themeDefinition']>({
    type: 'application',
    theme: {
      ...defaultThemes.light,
      enableNovaTokens: true,
    },
  });

  return (
    <ViyaThemeContainer
      themeDefinition={theme}
      viyaEndpoint={props.viyaEndpoint}
      style={{ width: '100%', height: '100%' }}
    >
      <SetThemeContext.Provider value={setTheme}>
        <TypographyWrapper
          requestFonts={props.requestFonts}
          ignoreRootFontSize={props.ignoreRootFontSize}
          dataProvider={props.typographyDataProvider}
        >
          {props.children}
        </TypographyWrapper>
      </SetThemeContext.Provider>
    </ViyaThemeContainer>
  );
};

const SetThemeContext = createContext<
  undefined | ((theme: ViyaThemeContainerProps['themeDefinition']) => void)
>(undefined);

/**
 * Hook for using the SetThemeContext
 */
export function useSetTheme() {
  return useContext(SetThemeContext);
}
